import { render, staticRenderFns } from "./VeJwBkXueshengModal__Style#Drawer.vue?vue&type=template&id=d36a58f6&scoped=true"
import script from "./VeJwBkXueshengModal__Style#Drawer.vue?vue&type=script&lang=js"
export * from "./VeJwBkXueshengModal__Style#Drawer.vue?vue&type=script&lang=js"
import style0 from "./VeJwBkXueshengModal__Style#Drawer.vue?vue&type=style&index=0&id=d36a58f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36a58f6",
  null
  
)

export default component.exports